import {Component, Injector} from '@angular/core';
import {WidgetDataControllerComponent} from '../../../../Controller/widget-data-controller-component';
import {EbitdaApiService} from '../../../../../Services/Api/Finances/Ebitda/ebitda-api.service';
import {ApiResponse} from '../../../../../Services/Api/base-api.service';
import {EbitdaData, EbitdaReportDto} from '../../../../../Models/Finances/Ebitda/ebitda-report.interface';
import {EbitdaFilters} from '../../../../../Models/Finances/Ebitda/ebitda-filters.model';

@Component({
  selector: 'app-ebitda-purchases-widget',
  templateUrl: './ebitda-purchases-widget.component.html',
  styleUrls: ['./ebitda-purchases-widget.component.scss'],
  standalone: false
})
export class EbitdaPurchasesWidgetComponent extends WidgetDataControllerComponent<EbitdaData> {

  get widgetData(): EbitdaData {
    return this.data ? this.data : this.fakeData;
  }

  constructor(
    protected override injector: Injector,
    protected ebitdaService: EbitdaApiService,
  ) {
    super(injector, ebitdaService);

    this.getFakeData();
  }


  /**
   * Obtener datos falsos
   *
   */
  getFakeData() {
    this.fakeData = {
      last_importe: 87197.67,
      last_porcentaje: 34.57,
      importe: 60651.20,
      porcentaje: 31.97,
      diferencia_importe: 43.76,
      diferencia_porcentaje: 30.44,
    };
  }


  /**
   * Obtener las compras
   *
   */
  override setData(data: EbitdaReportDto) {
    this.data = data.compras;
  }


  /**
   * Obtener datos
   *
   */
  getData(): Promise<ApiResponse> {
    const params: EbitdaFilters = new EbitdaFilters();

    if (this.widgetsManager.filters) {
      params.filtro_local = this.widgetsManager.filters.local?.id || params.filtro_local;
      params.fecha_desde = this.widgetsManager.filters.fecha_inicio || params.fecha_desde;
      params.fecha_hasta = this.widgetsManager.filters.fecha_fin || params.fecha_hasta;
    }

    return this.ebitdaService.getReportEbitda(params, false);
  }

}
